import { render, staticRenderFns } from "./food.quick.details.vue?vue&type=template&id=1f83c154&scoped=true&"
import script from "./food.quick.details.vue?vue&type=script&lang=js&"
export * from "./food.quick.details.vue?vue&type=script&lang=js&"
import style0 from "./food.quick.details.vue?vue&type=style&index=0&id=1f83c154&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f83c154",
  null
  
)

export default component.exports